import React from 'react';

import { Primitive, Tooltip } from '@rtkwlf/fenrir-react';
import type { ScheduleStatus, TargetStatus } from '@rtkwlf/rendall';
import { ScannerStatus as RendallScannerStatus } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';

import { ScannerBadge } from '../scanner-badge';

type StatusProps = {
  value?: RendallScannerStatus | TargetStatus | ScheduleStatus;
  size?: 'small' | 'medium';
};

export const ScannerStatus: React.FC<StatusProps> = ({ value, size }) => {
  const { t } = useTranslation();

  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <Primitive.span>
          <ScannerBadge
            value={value || RendallScannerStatus.Disconnected}
            size={size}
          />
        </Primitive.span>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Tooltip.Text>
          {t(`telemetryScanners:badgeTooltip.${value}`)}
        </Tooltip.Text>
      </Tooltip.Content>
    </Tooltip.Root>
  );
};
